<template>
	<div class="classTest-echarts"></div>
</template>

<script>
import echarts from 'echarts'
export default {
	props: {
		classDataTitle: Array,
		classGradeX: Array,
		newClassData: Array,
		max: Number,
		interval: Number
	},
	data() {
		return {}
	},
	watch: {
		classDataTitle: {
			handler() {
				this.drawTotalGrade()
			},
			newClassData: {
				handler() {
					// this.drawTotalGrade()
				}
			}
		}
	},
	mounted() {
		this.init()
	},
	methods: {
		init() {
			this.getData()
		},
		getData() {
			this.$nextTick(() => {
				this.drawTotalGrade()
			})
		},
		drawTotalGrade() {
			this.renderClassTest = echarts.init(document.querySelector(`.classTest-echarts`))
			this.renderClassTest.clear()
			this.renderClassTest.setOption({
				title: {
					left: 'center'
				},
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b} : {c}'
				},
				// color: ['rgb(105, 193, 112)', 'red', 'green'],
				legend: {
					left: 'center',
					icon: 'roundRect',
					selectedMode: false,
					data: this.classDataTitle.map(item => item.className)
				},
				xAxis: {
					type: 'category',
					name: '分档线',
					boundaryGap: true,
					splitLine: { show: false },
					// data: ['160', '171.5', '180']
					data: this.classGradeX
				},
				grid: {
					left: '3%',
					right: '8%',
					bottom: '3%',
					containLabel: true
				},
				yAxis: {
					type: 'value',
					name: '人数',
					min: 0,
					max: this.max,
					interval: this.interval,
					minorTick: {
						show: false
					},
					minorSplitLine: {
						show: false
					}
				},
				series: this.newClassData
				// series: [
				// 	{
				// 		name: '1班',
				// 		type: 'line',
				// 		data: [6, 9, 18, 0]
				// 	},

				// 	{
				// 		name: '2班',
				// 		type: 'line',
				// 		data: [14, 5, 10, 0]
				// 	},
				// 	{
				// 		name: '3班',
				// 		type: 'line',
				// 		data: [12, 8, 14, 0]
				// 	}
				// ]
			})
		}
	}
}
</script>

<style lang="less" scoped></style>
